import { registerBlockType } from '@wordpress/blocks';

import metadata from './block.json';
import deprecated from './deprecated';
import Edit from './edit';
import save from './save';

registerBlockType( metadata.name, {
  edit: Edit,
  save,
  deprecated
});
